declare namespace $ {

	type $shm_hitalama_map_widget_float_table_follower__offset_shm_hitalama_map_widget_float_table_select_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_select['bubble_offset'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['offset'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__align_shm_hitalama_map_widget_float_table_select_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_select['bubble_align'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['align'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__Anchor_shm_hitalama_map_widget_float_table_select_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_select['Anchor'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['Anchor'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__Sub_shm_hitalama_map_widget_float_table_select_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_select['Bubble'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['Sub'] >
	>
	export class $shm_hitalama_map_widget_float_table_select extends $mol_select {
		Follower( ): $shm_hitalama_map_widget_float_table_follower
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map